import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { PATHS } from '@/common';

interface PublicTokenRequest {
  public_token: string;
  plaid_account_ids?: string[];
}

const useExchangePublicPlaidTokenQuery = () => {
  const { mutateAsync, isLoading, isSuccess, isError } = useMutation(
    (data: PublicTokenRequest) => api.post(PATHS.EXCHANGE_PUBLIC_PLAID_TOKEN, data),
    {
      retry: 0,
    }
  );

  const sendPlaidPublicToken = useCallback(
    async (data: PublicTokenRequest) => {
      await mutateAsync(data);
    },
    [mutateAsync]
  );

  return {
    sendPlaidPublicToken,
    isLoading,
    isSuccess,
    isError,
  };
};

export default useExchangePublicPlaidTokenQuery;
